import React from 'react';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { PersonalLoanPrequalHighCcDebtView } from './PersonalLoanPrequalHighCcDebtView';
import { PERSONAL_LOAN_PREQUAL_HIGH_CC_DEBT } from 'types/morph.pagePosition.constants';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { PERSONAL_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';
import { redirectPersonalLoanOfferWithStaticModule } from 'actions/offers.actions';

const PersonalLoanPrequalHighCcDebtController = ({ ...props }) => {
  const attr = getViewModuleTrackingAttributes({
    pagePosition: PERSONAL_LOAN_PREQUAL_HIGH_CC_DEBT,
    modulePosition: props.modulePosition,
    vertical: 'Personal Loan',
  });

  useViewModule(attr);
  const seenPixel = useSeenModulePixel(attr);

  const onClickPrequal = () => {
    props.eventHandler(CLICK, {
      'Click Type': 'Check Pre-Qualification',
      'Module Position': props.modulePosition,
      Vertical: PERSONAL_LOAN_VERTICAL,
    });
    props.dispatch(
      redirectPersonalLoanOfferWithStaticModule(
        props.history,
        'PREQUAL_FUNNEL',
      ),
    );
  };

  return (
    <>
      {seenPixel}
      <PersonalLoanPrequalHighCcDebtView
        creditInfo={props.creditInfo}
        onClickPrequal={onClickPrequal}
      />
    </>
  );
};

export default PersonalLoanPrequalHighCcDebtController;
